// extracted by mini-css-extract-plugin
export default {"image":"biblebedtimestories_image__v4-BD","pageContent":"biblebedtimestories_pageContent__HS9Di"};